/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SchemaDefinition } from '../../openapi/v2/models/Oas20SchemaDefinition';
import { AddSchemaDefinitionCommand } from './AddSchemaDefinitionCommand';
import { Oas20Definitions } from '../../openapi/v2/models/Oas20Definitions';
import { Node } from '../../core/models/Node';

/**
 * OAI version 2.0 impl.
 * @author eric.wittmann@gmail.com
 * @extends AddSchemaDefinitionCommand
 * @class
 */
export class AddSchemaDefinitionCommand_20 extends AddSchemaDefinitionCommand {
    public _nullDefinitions : boolean;

    public constructor(definitionName? : any, from? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super(definitionName, from);
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else if(((typeof definitionName === 'string') || definitionName === null) && from === undefined) {
            let __args = arguments;
            super(definitionName);
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else if(definitionName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
            if(this._nullDefinitions===undefined) this._nullDefinitions = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#defExists(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {boolean}
     */
    defExists(document : OasDocument) : boolean {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.definitions)) {
            return false;
        }
        return !this.isNullOrUndefined(doc20.definitions.getDefinition(this._newDefinitionName));
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#prepareDocumentForDef(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    prepareDocumentForDef(document : OasDocument) {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.definitions)) {
            doc20.definitions = doc20.createDefinitions();
            this._nullDefinitions = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#createSchemaDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     * @return {OasSchema}
     */
    createSchemaDefinition(document : OasDocument) : OasSchema {
        let doc20 : Oas20Document = <Oas20Document>document;
        let definition : Oas20SchemaDefinition = doc20.definitions.createSchemaDefinition(this._newDefinitionName);
        Library.readNode(this._newDefinitionObj, definition);
        return definition;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#addDefinition(io.apicurio.datamodels.openapi.models.OasDocument, io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasDocument} document
     * @param {OasSchema} definition
     */
    addDefinition(document : OasDocument, definition : OasSchema) {
        let doc20 : Oas20Document = <Oas20Document>document;
        let def20 : Oas20SchemaDefinition = <Oas20SchemaDefinition>definition;
        doc20.definitions.addDefinition(this._newDefinitionName, def20);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand#removeDefinition(io.apicurio.datamodels.openapi.models.OasDocument)
     * @param {OasDocument} document
     */
    removeDefinition(document : OasDocument) {
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this._nullDefinitions) {
            doc20.definitions = null;
        } else {
            doc20.definitions.removeDefinition(this._newDefinitionName);
        }
    }
}
AddSchemaDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand_20";
AddSchemaDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




